import {
  Helmet,
} from 'react-helmet';

import {
  Image,
} from '@gymcloud/core';

type Props = {
  title: string;
  favicon: Image;
};

const HelmetContainer = ({ title, favicon }: Props) => (
  <Helmet defer={false}>
    <title>{title}</title>
    {favicon?.size_32?.url && (
      <link
        href={favicon.size_32.url}
        rel="icon"
        type="image/x-icon"
      />
    )}
  </Helmet>
);

export default HelmetContainer;
